import { createAction } from "redux-actions";
import { PersonalInfoConstant } from "./PersonalInfoConstant";

export const fetchPersonalInfo = createAction(
  PersonalInfoConstant.FETCH_PERSONAL_INFO
);
export const getProductVariant = createAction(
  PersonalInfoConstant.GET_PRODUCT_VARIANTS
);
